<template>
  <div :class="formGroupClass">
    <slot name="before"/>
    <label :for="inputId" class="control-label">{{ inputLabel }}</label>
    <div class="input-group">
      <date-picker
        :id="inputId"
        :disabled="disabled"
        :value-type="dateValueType"
        :format="dateFormat"
        :disabled-date="isDisabledDate"
        v-model="inputValue"
        v-facade="dateMask"
        @input="emitValue('input', $event)"
        @change="emitValue('change', $event)"
        @blur="emitValue('change', $event)"
      />
    </div>
    <div v-if="!isView">
      <a
          @click="changeIdentificationDateTo(identificationDateToClue)"
          class="identification-date-to-clue"
      >{{identificationDateToClue}}</a>
    </div>
    <error-help-block :has-errors="hasInputErrors" :current-error="actualErrorMessage"/>
    <slot name="after"/>
  </div>
</template>

<script>
import applicationInputMixin from '../../../../mixins/applicationInputMixin'
import applicationFormMixin from '../../../../mixins/applicationFormMixin'
import visitorsSectionMixin from '../../../../mixins/application-form/visitorsSectionMixin'
import visitorInputMixin from '../../../../mixins/application-form/visitorInputMixin'
import datePickerConfigMixin from '../../../../mixins/application-form/datePickerConfigMixin'
import moment from 'moment';

export default {
  name: 'IdentificationDateToInput',
  mixins: [
    applicationInputMixin,
    applicationFormMixin,
    visitorsSectionMixin,
    visitorInputMixin,
    datePickerConfigMixin
  ],

  props: {
    inputLabel: {
      default: 'Дата окончания'
    },

    inputName: {
      default: 'identification_date_to'
    },

    documentMasks: {
      type: Array,
      default: () => []
    }
  },

  computed: {
    inputId () {
      return `form-visitor-identification-date-to-${this.visitorIndex}`
    },

    identificationDateToClue() {
      let currentDocumentMask = this.documentMasks.find(documentMask =>
        documentMask.identification_id === this.visitor.personal.identification_id &&
          Number(documentMask.nationality_id) === this.visitor.personal.nationality_id
      )
      if (this.visitor.personal.identification_date_of !== null && currentDocumentMask &&
          currentDocumentMask.term_years !== null && currentDocumentMask.term_minus_days !== null) {
        let dateClue = moment(this.visitor.personal.identification_date_of, 'DD.MM.YYYY')
        dateClue.add(currentDocumentMask.term_years, 'years')
        dateClue.subtract(currentDocumentMask.term_minus_days, 'days')

        return dateClue.toDate().toLocaleDateString()
      }

      return null
    }
  },

  methods: {
    disabledDate (date) {
      return false
    },

    changeIdentificationDateTo(newDate) {
      this.visitor.personal.identification_date_to = newDate
    }
  }
}
</script>
